module.exports = __webpack_public_path__ + "img/rascrut-5.19eb09c6.webp";